import { createContext, useEffect, useState } from "react";
import axios from 'axios'
import { baseUrl, path, TOKEN_KEY } from "../constants";
import { api } from "../api";
import translate from "../i18n";

export const appContext = createContext()

export default function AppProvider(props){
    const [token, setToken] = useState(null)
    const [categories, setCategories] = useState(null)
    const [userLang, setUserLang] = useState('en')
    const [user, setUser] = useState({})
    const [showSidebar, setShowSidebar] = useState(false)

    useEffect(() => {
        axios(baseUrl + path.getCategories).then(response => {
            setCategories(response.data.categories)
        })
        let _token = localStorage.getItem(TOKEN_KEY)
        setToken(_token)
    }, [])

    useEffect(() => {
        if(token){
            api.get(path.myAccount).then(response => {
                let data = response.data
                if(data.success) {
                    setUser(data.user)
                    
                }
            })
        }
        
    }, [token])

    
    
    return (
        <appContext.Provider value={{token, setToken, categories, showSidebar, setShowSidebar}}>
            {props.children}
        </appContext.Provider>
    )
}